import { useState, useEffect, useRef } from "react";
import { authService } from "../services/authService";

export const useVerifyEmail = (token, navigate) => {
  const isMounted = useRef(true);
  const [status, setStatus] = useState({
    loading: true,
    success: false,
    alreadyVerified: false,
    message: "",
  });

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!token) {
      setStatus({
        loading: false,
        success: false,
        alreadyVerified: false,
        message: "Invalid verification link.",
      });
      return;
    }

    const verify = async () => {
      try {
        const res = await authService.verifyEmailToken(token);
        if (!isMounted.current) return;

        const { success = false, message = "", alreadyVerified = false } = res;

        if (success) {
          setStatus({
            loading: false,
            success: true,
            alreadyVerified: false,
            message: message || "Your email has been successfully verified.",
          });

          setTimeout(() => {
            if (isMounted.current) navigate("/sign-in");
          }, 2500);
          return;
        }

        setStatus({
          loading: false,
          success: false,
          alreadyVerified,
          message: message || "Verification failed.",
        });
      } catch (err) {
        if (!isMounted.current) return;
        setStatus({
          loading: false,
          success: false,
          alreadyVerified: false,
          message:
            err?.response?.data?.message ||
            "Server error. Please try again later.",
        });
      }
    };

    verify();
  }, [token, navigate]);

  return { status };
};
